export default __webpack_public_path__ + "static/media/logo.1f9d439a.svg";